import { call, put } from "redux-saga/effects";
import httpErrorHelpers from "../../services/httpUtilities/httpErrorHelpers";
import api from "../../services/httpUtilities/httpService";
import * as registrationAction from "../actions/registration";

//Registration
function* watcherRegistrationRequest({ nric,recaptchaToken }, effects) {
  try {
    const response = yield call(api.registrationReq, nric,recaptchaToken);
    const { data, status } = response;
    const { Message } = data;
    
    //console.log("res",response);
    if (status === 200) {
      yield put(registrationAction.registrationSuccess(data.Data));
    } else {
      const message = "Registration Unsuccessful";
      yield put(registrationAction.registrationFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.registrationFailure,
      effects
    );
  }
}

//Registration Otp Req
function* watcherRegistrationOTPRequest({ nric }, effects) {
  try {
    const response = yield call(api.registrationOTPReq, nric);
    const { data, status } = response;
    const { Message } = data;
    //console.log("res",response);
    if (status === 200) {
      yield put(registrationAction.registrationOtpSuccess(data));
    } else {
      const message = "Registration OTP Request Unsuccessful";
      yield put(registrationAction.registrationOtpFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.registrationOtpFailure,
      effects
    );
  }
}

//Registration Otp Verify
function* watcherRegistrationOTPVerify(
  { nric, otpReference, c2facode, mobileNo, mobileCountryCode },
  effects
) {
  try {
    const response = yield call(
      api.registrationVerifyOTP,
      nric,
      otpReference,
      c2facode,
      mobileNo,
      mobileCountryCode
    );
    const { data, status } = response;
    const { Message } = data;
     //console.log("res123",response);
    if (status === 200) {
      yield put(registrationAction.registrationOtpVerifySuccess(data));
    } else {
      const message = "Registration OTP Verify Unsuccessful";
      yield put(registrationAction.registrationOtpVerifyFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.registrationOtpVerifyFailure,
      effects
    );
  }
}

//Activation Generic Link Req
function* watcherActivationGenericLinkReq(
  { userID, password, confirmPassword, nric, dob },
  effects
) {
  try {
    const response = yield call(
      api.activationGenericLink,
      userID,
      password,
      confirmPassword,
      nric,
      dob
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res",response);
    if (status === 200) {
      yield put(registrationAction.activationGenericLinkSuccess(data));
    } else {
      const message = "Activation Generic Link Req  Unsuccessful";
      yield put(registrationAction.activationGenericLinkFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.activationGenericLinkFailure,
      effects
    );
  }
}

//Activation Generic Link OTP verify
function* watcherActivationGenericOtpVerify(
  { nric, otpReferenceNo, code, password, userID },
  effects
) {
  try {
    const response = yield call(
      api.activationGenericValidateOTP,
      nric,
      otpReferenceNo,
      code,
      password,
      userID
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res",response);
    if (status === 200) {
      yield put(registrationAction.activationGenericOTPVerifySuccess(data));
    } else {
      const message = "Activation Generic  OTP Verify Unsuccessful";
      yield put(registrationAction.activationGenericOTPVerifyFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.activationGenericOTPVerifyFailure,
      effects
    );
  }
}

//Activation Personal Link Req
function* watcherActivationPersonalLinkReq({ q, a, r }, effects) {
  try {
    const response = yield call(api.activationPersonalLinkUrl, q, a, r);
    const { data, status } = response;
    const { Message } = data;
    //console.log("res",response);
    if (status === 200) {
      yield put(registrationAction.activationPersonalLinkReqSuccess(data));
    } else {
      const message = "Activation Personal Link Req  Unsuccessful";
      yield put(registrationAction.activationPersonalLinkReqFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.activationPersonalLinkReqFailure,
      effects
    );
  }
}

//Activate Personal Req
function* watcherActivatePersonalReq(
  { nric, userID, password, confirmPassword, nricFromLink },
  effects
) {
  try {
    const response = yield call(
      api.activationPersonalLink,
      nric,
      userID,
      password,
      confirmPassword,
      nricFromLink
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res",response);
    if (status === 200) {
      yield put(registrationAction.activatePersonalReqSuccess(data));
    } else {
      const message = "Activate Personal Req  Unsuccessful";
      yield put(registrationAction.activatePersonalReqFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.activatePersonalReqFailure,
      effects
    );
  }
}

//Prompt MobilePhone Input
function* watcherPromptMobilePhoneInput(
  {nric, mobileNo, mobileCountryCode,recaptchaToken },
  effects
) {
  try {
    const response = yield call(
      api.promptMobilePhoneInput,
      nric,
      mobileNo,
      mobileCountryCode,recaptchaToken
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res",response);
    if (status === 200) {
      yield put(registrationAction.promptMobilePhoneInputSuccess(data));
    } else {
      const message = "Prompt Mobile Phone Input Unsuccessful";
      yield put(registrationAction.promptMobilePhoneInputFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.promptMobilePhoneInputFailure,
      effects
    );
  }
}

//Update Client Info
function* watcherUpdateClientInfo(
  { nric, userId, password, email, dateOfBirth, name },
  effects
) {
  try {
    const response = yield call(
      api.registrationUpdateClientInfo,
      nric,
      userId,
      password,
      email,
      dateOfBirth,
      name
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res",response);
    if (status === 200) {
      yield put(registrationAction.updateClientInfoSuccess(data));
    } else {
      const message = "Update Client Info Unsuccessful";
      yield put(registrationAction.updateClientInfoFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.updateClientInfoFailure,
      effects
    );
  }
}

//Registration Resend Otp
function* watcherRegistrationResendOTP(
  { nric },
  effects
) {
  try {
    const response = yield call(
      api.registrationOTPResend,
      nric,
      
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res",response);
    if (status === 200) {
      yield put(registrationAction.registrationOtpResendSuccess(data));
    } else {
      const message = "Registration Otp Resend Unsuccessful";
      yield put(registrationAction.registrationOtpResendFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.registrationOtpResendFailure,
      effects
    );
  }
}


//Validate Movie Reg
function* watcherValidateMovieReg(
  { nric,dob },
  effects
) {
  try {
    const response = yield call(
      api.validateMovieReg,
      nric,dob
      
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res",response);
    if (status === 200) {
      yield put(registrationAction.validateMovieRegSuccess(data));
    } else {
      const message = "Validate Movie Reg Unsuccessful";
      yield put(registrationAction.validateMovieRegFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.validateMovieRegFailure,
      effects
    );
  }
}

//Submit Movie Reg
function* watcherSubmitMovieReg(
  { otp,otpReference},
  effects
) {
  try {
    const response = yield call(
      api.submitMovieReg,
      otp,otpReference
      
    );
    const { data, status } = response;
    const { Message } = data;
    //console.log("res",response);
    if (status === 200) {
      yield put(registrationAction.submitMovieRegSuccess(data));
    } else {
      const message = "Submit Movie Reg Unsuccessful";
      yield put(registrationAction.submitMovieRegFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.submitMovieRegFailure,
      effects
    );
  }
}

function* watcherSubmitCampaignFormReq({bodyData}, effects) {
  try {
    const response = yield call(api.submitCampaignFormReq,bodyData);
    const { data, status } = response;
    //console.log("res",response)
    if (status === 200) {
      yield put(registrationAction.submitCampaignFormReqSuccess(data));
    } else {
      const message = "submitCampaignFormReqFailure Unsuccessful";
      yield put(registrationAction.submitCampaignFormReqFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.submitCampaignFormReqFailure,
      effects
    );
  }
}

function* watcherCalculateWalkWagAmountReq({bodyData}, effects) {
  try {
    const response = yield call(api.calculateWalkWagAmountReq,bodyData);
    const { data, status } = response;
    //console.log("res",response)
    if (status === 200) {
      yield put(registrationAction.calculateWalkWagAmountReqSuccess(data));
    } else {
      const message = "calculateWalkWagAmountReqFailure Unsuccessful";
      yield put(registrationAction.calculateWalkWagAmountReqFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.calculateWalkWagAmountReqFailure,
      effects
    );
  }
}

function* watcherCheckPayNowQRStatusReq({bodyData}, effects) {
  try {
    const response = yield call(api.checkPayNowQRStatusReq,bodyData);
    const { data, status } = response;
    //console.log("res",response)
    if (status === 200) {
      yield put(registrationAction.checkPayNowQRStatusReqSuccess(data));
    } else {
      const message = "checkPayNowQRStatusReqFailure Unsuccessful";
      yield put(registrationAction.checkPayNowQRStatusReqFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.checkPayNowQRStatusReqFailure,
      effects
    );
  }
}

function* watcherGetRegistrationCustomerDetails({bodyData}, effects) {
  try {
    const response = yield call(api.getRegistrationCustomerDetails,bodyData);
    const { data, status } = response;
    console.log("res9999",response)
    if (status === 200) {
      yield put(registrationAction.getRegistrationCustomerDetailsSuccess(data));
    } else {
      const message = "getRegistrationCustomerDetailsFailure Unsuccessful";
      yield put(registrationAction.getRegistrationCustomerDetailsFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.getRegistrationCustomerDetailsFailure,
      effects
    );
  }
}

function* watcherRegisterNewCustomer({bodyData}, effects) {
  try {
    const response = yield call(api.registerNewCustomer,bodyData);
    const { data, status } = response;
    console.log("res888",response)
    if (status === 200) {
      yield put(registrationAction.registerNewCustomerSuccess(data));
    } else {
      const message = "registerNewCustomerFailure Unsuccessful";
      yield put(registrationAction.registerNewCustomerFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.registerNewCustomerFailure,
      effects
    );
  }
}

//revamp 2.0
function* watcherGetRegistrationCustomerInfo({bodyData}, effects) {
  try {
    const response = yield call(api.getRegistrationCustomerInfo,bodyData);
    const { data, status } = response;
    console.log("res888",response)
    if (status === 200) {
      yield put(registrationAction.getRegistrationCustomerInfoSuccess(data));
    } else {
      const message = "getRegistrationCustomerInfoFailure Unsuccessful";
      yield put(registrationAction.getRegistrationCustomerInfoFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.getRegistrationCustomerInfoFailure,
      effects
    );
  }
}

function* watcherGetLoginToken({bodyData}, effects) {
  try {
    const response = yield call(api.getLoginToken,bodyData);
    const { data, status } = response;
    console.log("res888",response)
    if (status === 200) {
      yield put(registrationAction.getLoginTokenSuccess(data));
    } else {
      const message = "getLoginTokenFailure Unsuccessful";
      yield put(registrationAction.getLoginTokenFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.getLoginTokenFailure,
      effects
    );
  }
}

function* watcherGenerateOTPOnboarding({bodyData}, effects) {
  try {
    const response = yield call(api.generateOTPOnboarding,bodyData);
    const { data, status } = response;
    console.log("res888",response)
    if (status === 200) {
      yield put(registrationAction.generateOTPOnboardingSuccess(data));
    } else {
      const message = "generateOTPOnboardingFailure Unsuccessful";
      yield put(registrationAction.generateOTPOnboardingFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.generateOTPOnboardingFailure,
      effects
    );
  }
}

function* watcherRegisterNewCustomerv2({bodyData}, effects) {
  try {
    const response = yield call(api.registerNewCustomerv2,bodyData);
    const { data, status } = response;
    console.log("res888",response)
    if (status === 200) {
      yield put(registrationAction.registerNewCustomerv2Success(data));
    } else {
      const message = "registerNewCustomerv2Failure Unsuccessful";
      yield put(registrationAction.registerNewCustomerv2Failure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.registerNewCustomerv2Failure,
      effects
    );
  }
}

function* watcherLogRegistrationRequest({bodyData}, effects) {
  try {
    const response = yield call(api.logRegistrationRequest,bodyData);
    const { data, status } = response;
    console.log("res888",response)
    if (status === 200) {
      yield put(registrationAction.logRegistrationRequestSuccess(data));
    } else {
      const message = "logRegistrationRequestFailure Unsuccessful";
      yield put(registrationAction.logRegistrationRequestFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.logRegistrationRequestFailure,
      effects
    );
  }
}

function* watcherValidateRegistration({bodyData}, effects) {
  try {
    const response = yield call(api.validateRegistration,bodyData);
    const { data, status } = response;
    console.log("res888",response)
    if (status === 200) {
      yield put(registrationAction.validateRegistrationSuccess(data));
    } else {
      const message = "validateRegistrationFailure Unsuccessful";
      yield put(registrationAction.validateRegistrationFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.validateRegistrationFailure,
      effects
    );
  }
}

function* watcherUploadOcrNric({bodyData}, effects) {
  try {
    const response = yield call(api.uploadOcrNric,bodyData);
    const { data, status } = response;
    console.log("res888",response)
    if (status === 200) {
      yield put(registrationAction.uploadOcrNricSuccess(data));
    } else {
      const message = "uploadOcrNricFailure Unsuccessful";
      yield put(registrationAction.uploadOcrNricFailure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.uploadOcrNricFailure,
      effects
    );
  }
}

function* watcherUpdateClientInfov4Request({bodyData}, effects) {
  try {
    const response = yield call(api.updateClientInfov4,bodyData);
    const { data, status } = response;
    console.log("res888",response)
    if (status === 200) {
      yield put(registrationAction.updateClientInfov4Success(data));
    } else {
      const message = "updateClientInfov4Failure Unsuccessful";
      yield put(registrationAction.updateClientInfov4Failure(message));
    }
  } catch (error) {
    yield call(
      httpErrorHelpers,
      error,
      registrationAction.updateClientInfov4Failure,
      effects
    );
  }
}

export {
  watcherRegistrationRequest,
  watcherRegistrationOTPRequest,
  watcherRegistrationOTPVerify,
  watcherActivationGenericLinkReq,
  watcherActivationGenericOtpVerify,
  watcherActivationPersonalLinkReq,
  watcherActivatePersonalReq,
  watcherPromptMobilePhoneInput,
  watcherUpdateClientInfo,
  watcherRegistrationResendOTP,
  watcherValidateMovieReg,
  watcherSubmitMovieReg,
  watcherSubmitCampaignFormReq,
  watcherCalculateWalkWagAmountReq,
  watcherCheckPayNowQRStatusReq,
  watcherGetRegistrationCustomerDetails,
  watcherRegisterNewCustomer,

  //revamp 2.0
  watcherGetRegistrationCustomerInfo,
  watcherGetLoginToken,
  watcherGenerateOTPOnboarding,
  watcherRegisterNewCustomerv2,
  watcherLogRegistrationRequest,
  watcherValidateRegistration,
  watcherUploadOcrNric,
  watcherUpdateClientInfov4Request,
};
